<div class="modal-header">
  <h4 class="modal-title">&nbsp;</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <h4 class="modal-title">{{ 'IDS_NO_PAYMENT_METHOD_REDIRECT_TITLE' | translate }}</h4>
  <div [innerHTML]="'IDS_NO_PAYMENT_METHOD_REDIRECT' | translate"></div>
</div>
<div class="modal-footer">
  <button type="button" ngbAutofocus class="btn btn-outline-dark" (click)="activeModal.close()">{{ 'IDS_CONFIRM_PAYMENT' | translate }}</button>
</div>